<template>
    <div>
        <component :is="formWrapper" class="invite-friend-form-wrapper">
            <formFieldRow
                :name="['surname', 'givenName']"
                :label="$t('friend.invitation.name')"
                :errors="errors"
                :required="true"
                class="field-surname field-givenName"
            >
                <template #default="{hasError}">
                    <div class="flex flex-col sm:flex-row items-start">
                        <input
                            class="form-input w-full mb-2 sm:w-32 sm:mr-2 sm:mb-0"
                            :class="{ 'border-red': hasError }"
                            type="text"
                            v-model.trim="form.surname"
                            :placeholder="$t('account.surname')"
                        />
                        <input
                            class="form-input w-full sm:flex-1"
                            :class="{ 'border-red': hasError }"
                            type="text"
                            v-model.trim="form.givenName"
                            :placeholder="$t('account.given.name')"
                        />
                    </div>
                </template>
            </formFieldRow>
            <formFieldRow
                :name="'nickname'"
                :label="$t('friend.invitation.nickname')"
                :errors="errors"
                :required="true"
                class="field-nickname"
            >
                <template #default="{ hasError }">
                    <div class="flex flex-col sm:flex-row items-center">
                        <input
                            class="form-input w-full mb-2 sm:w-32 sm:mr-2 sm:mb-0"
                            :class="{
                                'border-red': hasError
                            }"
                            type="text"
                            maxlength="6"
                            v-model.trim="form.nickname"
                        />
                        <div class="text-sm">
                            暱稱最多6字，會顯示於送貨包裹外
                        </div>
                    </div>
                </template>
            </formFieldRow>
            <formFieldRow
                :name="'email'"
                :label="$t('friend.invitation.email')"
                :errors="errors"
                :required="true"
                class="field-email"
            >
                <template #default="{hasError}">
                    <input
                        class="form-input w-full"
                        :class="{ 'border-red': hasError }"
                        v-model.trim="form.email"
                        type="email"
                    />
                </template>
            </formFieldRow>
        </component>
        <errorBox :message="errors.server" />
        <slot
            name="buttons"
            :saveStatus="saveStatus"
            :save="save"
            :isReactivate="isReactivate"
        >
            <div class="flex justify-end">
                <loadingButton
                    class="btn btn-primary"
                    :status="saveStatus"
                    @click="save"
                    @successShown="saveStatus = undefined"
                >
                    {{ '邀請親友' }}
                </loadingButton>
            </div>
        </slot>
    </div>
</template>

<script>
import { instance } from '../utils/ajax';
import { validate } from '../utils/validationUtil';
import formFieldRow from './formFieldRow.vue';
import errorBox from './errorBox.vue';

async function inviteFriend(form) {
    try {
        let result = await instance.post(
            '/api/friendAccount/inviteFriend',
            form
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error invite friend');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: {
        formFieldRow,
        errorBox
    },
    props: {
        formWrapper: { default: 'div' }
    },
    data() {
        return {
            form: {
                surname: undefined,
                givenName: undefined,
                nickname: undefined,
                email: undefined
            },
            errors: {},
            saveStatus: undefined,
            isReactivate: false
        };
    },
    methods: {
        async save() {
            this.errors = {};
            const v = validate(this.errors, this.form, {
                surname: { required: true },
                givenName: { required: true },
                nickname: { required: true },
                email: { required: true }
            });
            if (v.hasError) {
                this.errors = v.errors;
                this.scrollToError();
                return;
            }
            this.saveStatus = 'loading';
            const result = await inviteFriend(this.form);
            if (result.success) {
                this.saveStatus = 'success';
                this.isReactivate = result.data.isReactivate;
            } else {
                this.saveStatus = undefined;
                this.errors = result.data.errors;
            }
        },
        scrollToError() {
            const field = Object.keys(this.errors)[0];
            if (field) {
                const target = this.$el.querySelector('.field-' + field);
                target.scrollIntoView();
            }
        }
    }
};
</script>
